import React, { Component } from "react"
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox"
import MasonryWall from "components/shared/MasonryWall"
import GalleryGridItem from "./GalleryGridItem"
import Button from "components/shared/Button"

class GalleryGrid extends Component {
    
    constructor(props) {
        super(props)

        this.state = {
            paginationLimit: 12,
            filter: 'reload',
            postCount: 0,
            postsHtml: "",
            filterActive: false,
            activeImage: 0,
            images: this.props.images
        }

        this.instance = null
        this.postsPerPage = 12

        if (this.props.columns !== 4) {
            this.sizes = {
                default: this.props.columns 
            }
        } else {
            this.sizes = {
                default: 4,
                992: 3,
                768: 2
            }
        }

        this.setImages = this.setImages.bind(this)
        this.viewMoreImages = this.viewMoreImages.bind(this)
    }

    componentDidMount() {
        this.setImages(this.props.images)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.images !== this.props.images) {
            this.setState({
                images: this.props.images
            })
            this.setImages(this.props.images)
        }
    }

    viewMoreImages() {
        this.setState((state) => {
            return { paginationLimit: (state.paginationLimit + this.postsPerPage) }
        }, this.setImages)
    } 

    setImages(images=null) {
        let { paginationLimit } = this.state
        let postCount = 0
        let postsHtml
        let currentImages = images

        if (currentImages === null) currentImages = this.state.images

        if (currentImages.length > 0) {
            postsHtml = currentImages.map((image, i) => {
                if (postCount < paginationLimit) {
                    postCount++
                    if (image) {
                        return (
                            <GalleryGridItem
                                key={i}
                                // size={this.calcSize(image.localFile.resize.gatsbyImageData.height)}
                                thumbnail={image.localFile.resize.gatsbyImageData}
                                largeImage={image.localFile.publicURL}
                                altText={image.altText}
                                borderOnHover={this.props.borderOnHover}
                            />
                        )
                    } else {
                        return null
                    }
                } else {
                    return null
                }
            })

            this.setState({
                postsHtml
            })
        }
    }

    render() {
        const lightboxOptions = {
            buttons: {
                showDownloadButton: false,
                showAutoplayButton: false,
                showFullscreenButton: false
            }
        } 
        return(
            <SimpleReactLightbox>
                <SRLWrapper options={lightboxOptions}>
                    <MasonryWall breakpoints={this.sizes}>
                        {this.state.postsHtml}
                    </MasonryWall>
                </SRLWrapper>
                {this.state.paginationLimit < this.props.images.length &&
                    <div className="pt-3">
                        <Button as="button" onClick={this.viewMoreImages} color="black">
                            <span>View more images</span>
                        </Button>
                    </div>
                }
            </SimpleReactLightbox>
        )
    }
}

GalleryGrid.defaultProps = {
    columns: 4,
    borderOnHover: false
}

export default GalleryGrid